import { useOnline } from '../hooks/useOnline';

/**
 * Pruh, ktorý povie, že appka nemá sieť.
 *
 * Sedí pod hlavičkou a odsúva obsah, nie prekrýva — správa o tom, že sa nedá
 * pracovať, nesmie zakryť to, na čo sa človek práve pozerá. Čo už je stiahnuté,
 * ostáva čitateľné; nefunguje len to, čo potrebuje server.
 */
export const OfflineBar = () => {
  const online = useOnline();

  if (online) {
    return null;
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center justify-center gap-2 bg-amber-500/15 px-4 py-2 text-[13px] font-medium text-amber-800 dark:bg-amber-400/15 dark:text-amber-300"
    >
      <span
        className="h-1.5 w-1.5 shrink-0 rounded-full bg-amber-500"
        aria-hidden="true"
      />
      {/* Sľubuje presne to, čo fronta (lib/offlineQueue.ts) naozaj spraví — nie
          viac. Appka nemá tvrdiť, že sa uloží aj to, čo sa neuloží. */}
      Bez pripojenia. Komentáre, správy, poznámky, úlohy a presuny tiketov sa odošlú,
      keď bude sieť — ostatné sa teraz uložiť nedá.
    </div>
  );
};
